/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import {
  Check,
  RefreshCw,
  Info,
  X,
  AlertCircle,
  Clock,
  Activity,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";
import { DHD_PLAN_NAME } from "../../DhdCurrentPlanBanner";

export default function ActivationTiktokPixel({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const products = useSelector((state) => state.ProductsReducer);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useStoreFormDraft(store);
  const [isPixelActive, setIsPixelActive] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsPixelActive(Boolean(store?.tiktokPixel));
  }, [store]);

  // Add SweetAlert styling for z-index
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: t("servicePageActivation.tiktokPixel.alerts.ok"),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  const clearPixelValue = (pixelKey) => {
    setData({ ...data, [pixelKey]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isDeactivating = !data.tiktokPixel || data.tiktokPixel.trim() === "";

    if (!isDeactivating) {
      if (!data.tiktokPixel || data.tiktokPixel.trim() === "") {
        await showAlert(
          "warning",
          t("servicePageActivation.tiktokPixel.pixelIdRequired"),
          t("servicePageActivation.tiktokPixel.pixelIdInactiveWarning"),
        );
        return;
      }
    } else {
      const result = await showAlert(
        "warning",
        t("servicePageActivation.tiktokPixel.alerts.deactivateTitle"), // <-- à ajouter dans ton fichier de traduction
        t("servicePageActivation.tiktokPixel.alerts.deactivateText"), // <-- à ajouter aussi
      );

      if (!result.isConfirmed) {
        return;
      }
    }

    apicache(account, products);
    setLoading(true);

    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));
      setLoading(false);
      setIsPixelActive(!isDeactivating);

      if (isDeactivating) {
        await showAlert(
          "success",
          t("servicePageActivation.tiktokPixel.alerts.deactivatedSuccess"),
          "",
        );
      } else {
        await showAlert(
          "success",
          t("servicePageActivation.tiktokPixel.alerts.activatedSuccess"),
          "",
        );
      }

      close();
    } catch (error) {
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "error",
          t("servicePageActivation.tiktokPixel.alerts.deactivationErrorTitle"),
          t("servicePageActivation.tiktokPixel.alerts.errorText"),
        );
      } else {
        await showAlert(
          "error",
          t("servicePageActivation.tiktokPixel.alerts.activationErrorTitle"),
          t("servicePageActivation.tiktokPixel.alerts.errorText"),
        );
      }
    }
  };

  const handlePixelSubmit = async (pixelKey, pixelNumber) => {
    const pixelValue = data[pixelKey];
    const isDeactivating = !pixelValue || pixelValue.trim() === "";

    if (!isDeactivating) {
      if (!pixelValue || pixelValue.trim() === "") {
        await showAlert(
          "warning",
          `معرف البكسل ${pixelNumber} مطلوب`,
          "يرجى إدخال معرف بكسل صالح",
        );
        return;
      }
    }

    apicache(account, products);
    setLoading(true);

    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "success",
          `تم إلغاء تفعيل معرف البكسل ${pixelNumber} بنجاح`,
          "",
        );
      } else {
        await showAlert(
          "success",
          `تم تفعيل معرف البكسل ${pixelNumber} بنجاح`,
          "",
        );
      }
    } catch (error) {
      setLoading(false);
      await showAlert("error", "حدث خطأ", "فشل في تحديث معرف البكسل");
    }
  };

  const renderPixelField = (pixelKey, pixelNumber, isDisabled = false) => {
    const pixelValue = data[pixelKey] || "";
    const isActive = Boolean(pixelValue);

    return (
      <div className="mb-5">
        <div className="flex justify-between items-center mb-2">
          <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
            {t("servicePageActivation.tiktokPixel.pixelIdLabel")} {pixelNumber}
          </label>
          <div
            className={`px-2 py-1 rounded-full text-xs font-medium ${
              isActive
                ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:!text-green-300"
                : "bg-gray-100 text-gray-800 dark:!bg-gray-700 dark:!text-gray-300"
            }`}
          >
            {isActive ? t("ui.enabledCheck") : t("ui.stopped")}
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-3">
          <div className="relative flex-grow">
            <input
              type="text"
              disabled={isDisabled}
              placeholder={t(
                "servicePageActivation.facebookApiConversion.form.pixelIdPlaceholder",
              )}
              value={pixelValue}
              onChange={(e) => {
                const value = e.target.value.replace(/\s+/g, "");
                setData({ ...data, [pixelKey]: value });
              }}
              className={`w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-500 dark:!bg-[#141414] dark:!text-gray-200 pr-10 ${
                isDisabled
                  ? "opacity-50 cursor-not-allowed bg-gray-100 dark:!bg-gray-800"
                  : ""
              }`}
            />
            {pixelValue && !isDisabled && (
              <button
                type="button"
                onClick={() => clearPixelValue(pixelKey)}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:!bg-gray-600"
                title={t("ui.clear")}
              >
                <X size={16} />
              </button>
            )}
          </div>

          <button
            type="button"
            disabled={loading || isDisabled}
            onClick={() => handlePixelSubmit(pixelKey, pixelNumber)}
            className={`px-6 py-2.5 ${
              pixelValue && !isDisabled
                ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                : "bg-red-500 hover:bg-red-600"
            } text-white font-medium rounded-lg transition-colors flex items-center justify-center min-w-[120px] ${
              loading || isDisabled ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? (
              <RefreshCw className="animate-spin" size={18} />
            ) : pixelValue ? (
              t("services.printAgent.activate")
            ) : (
              t("servicePageActivation.tiktokPixel.deactivate")
            )}
          </button>
        </div>

        {isDisabled && (
          <p className="text-amber-600 text-sm mt-1">
            {t("ui.premiumPlansOnly")}
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-[400px] h-fit p-6">
      {/* Page Header */}
      <div className="mb-6 dark:!bg-[#181919] dark:!border-[#3c3a3d] border p-6 rounded-xl">
        <h1 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="ml-2"
          >
            <path
              d="M19.0566 8.09125C17.4091 8.09063 15.849 7.44341 14.686 6.28158V15.7381C14.6854 16.7369 14.4095 17.7131 13.8887 18.5593C13.3679 19.4055 12.6251 20.0881 11.7423 20.5248C10.8595 20.9615 9.87217 21.1355 8.89276 21.0256C7.91336 20.9157 6.98398 20.5262 6.21286 19.9034C5.44174 19.2806 4.8611 18.4515 4.54053 17.515C4.21997 16.5785 4.1729 15.5686 4.40565 14.6081C4.6384 13.6477 5.14101 12.7797 5.85313 12.1106C6.56525 11.4415 7.45576 10.9998 8.4116 10.8423V13.7271C8.14149 13.8486 7.9074 14.0418 7.73196 14.2878C7.55652 14.5339 7.44597 14.8244 7.41078 15.1305C7.37558 15.4365 7.41697 15.7477 7.53111 16.0336C7.64526 16.3195 7.82893 16.5699 8.0645 16.7594C8.30007 16.9489 8.57913 17.071 8.87592 17.1132C9.17272 17.1554 9.47539 17.1161 9.75277 17.0002C10.0302 16.8842 10.2702 16.6953 10.445 16.4542C10.6198 16.2131 10.7225 15.9288 10.7424 15.634V2.90002H13.7258C13.7307 3.36653 13.8333 3.82646 14.0269 4.24827C14.2206 4.67008 14.4999 5.04336 14.8463 5.34379C15.1926 5.64422 15.5969"
              fill="#9e68ba"
            />
          </svg>
          {t("servicePageActivation.tiktokPixel.title")}
        </h1>
        <p className="text-gray-600 dark:!text-gray-300">
          {t("servicePageActivation.tiktokPixel.description")}
        </p>
      </div>

      {/* Service Status Indicator */}
      <div
        className={`mb-4 p-3 rounded-lg ${
          isPixelActive
            ? "bg-green-50 border border-green-200 dark:!bg-[#181919] dark:!border-[#3c3a3d]"
            : "bg-gray-50 border border-gray-200 dark:!bg-[#181919] dark:!border-[#3c3a3d]"
        }`}
      >
        <div className="flex gap-x-2 items-center">
          <div
            className={`w-3 h-3 rounded-full mr-2 ${
              isPixelActive ? "bg-green-500" : "bg-gray-400 dark:!bg-gray-500"
            }`}
          ></div>
          <span
            className={`text-sm font-medium ${
              isPixelActive
                ? "text-green-700"
                : "text-gray-700 dark:!text-gray-300"
            }`}
          >
            {isPixelActive
              ? t("servicePageActivation.tiktokPixel.statusActive")
              : t("servicePageActivation.tiktokPixel.statusInactive")}
          </span>
        </div>
      </div>

      {/* Activation Form */}
      <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] p-6 mb-6">
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-[#9e68ba] mb-4 flex items-center">
              <Activity className="ml-2" size={18} />
              {t("servicePageActivation.tiktokPixel.settingsTitle")}
            </h3>

            {/* Main Pixel ID */}
            <div className="mb-5">
              <div className="flex justify-between items-center mb-2">
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("servicePageActivation.tiktokPixel.pixelIdLabel")}
                  <span className="text-red-500">*</span>
                </label>
                <div
                  className={`px-2 py-1 rounded-full text-xs font-medium ${
                    isPixelActive
                      ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:!text-green-300"
                      : "bg-gray-100 text-gray-800 dark:!bg-gray-700 dark:!text-gray-300"
                  }`}
                >
                  {isPixelActive
                    ? t("servicePageActivation.tiktokPixel.statusEnabled")
                    : t("servicePageActivation.tiktokPixel.statusDisabled")}
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-3">
                <div className="relative flex-grow">
                  <input
                    type="text"
                    placeholder={t(
                      "servicePageActivation.facebookApiConversion.form.pixelIdPlaceholder",
                    )}
                    value={data.tiktokPixel || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\s+/g, "");
                      setData({ ...data, tiktokPixel: value });
                    }}
                    className="w-full px-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 focus:border-purple-500 dark:!bg-[#141414] dark:!text-gray-200 pr-10"
                  />
                  {data.tiktokPixel && (
                    <button
                      type="button"
                      onClick={() => clearPixelValue("tiktokPixel")}
                      className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:!bg-gray-600"
                      title={t("servicePageActivation.tiktokPixel.clearTitle")}
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className={`px-6 py-2.5 ${
                    data.tiktokPixel
                      ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                      : "bg-red-500 hover:bg-red-600"
                  } text-white font-medium rounded-lg transition-colors flex items-center justify-center min-w-[120px] ${
                    loading ? "opacity-70 cursor-not-allowed" : ""
                  }`}
                >
                  {loading ? (
                    <RefreshCw className="animate-spin" size={18} />
                  ) : data.tiktokPixel ? (
                    t("servicePageActivation.tiktokPixel.activate")
                  ) : (
                    t("servicePageActivation.tiktokPixel.deactivate")
                  )}
                </button>
              </div>

              {!data.tiktokPixel && !isPixelActive && (
                <p className="text-amber-600 text-sm mt-1">
                  {t(
                    "servicePageActivation.tiktokPixel.pixelIdInactiveWarning",
                  )}
                </p>
              )}
              {!data.tiktokPixel && isPixelActive && (
                <p className="text-red-500 text-sm mt-1">
                  {t("servicePageActivation.tiktokPixel.pixelIdRequired")}
                </p>
              )}
            </div>

            {/* Additional Pixel Fields */}
            <>
              {/* Pixel 2 */}
              {renderPixelField(
                "tiktokPixel2",
                2,
                account?.subscription?.plan !== "الأسطورية" &&
                  account?.subscription?.plan !== DHD_PLAN_NAME &&
                  account?.subscription?.plan !== "الاحترافية" &&
                  account?.subscription?.plan !== "المتطورة",
              )}

              {/* Pixel 3 */}
              {renderPixelField(
                "tiktokPixel3",
                3,
                account?.subscription?.plan !== "الأسطورية" &&
                  account?.subscription?.plan !== DHD_PLAN_NAME &&
                  account?.subscription?.plan !== "الاحترافية",
              )}

              {/* Pixel 4 */}
              {renderPixelField(
                "tiktokPixel4",
                4,
                account?.subscription?.plan !== "الأسطورية" &&
                  account?.subscription?.plan !== DHD_PLAN_NAME &&
                  account?.subscription?.plan !== "الاحترافية",
              )}
            </>

            <div className="mt-2 text-sm text-gray-600 dark:!text-gray-400">
              <p>{t("servicePageActivation.tiktokPixel.helpText1")}</p>
              <p>{t("servicePageActivation.tiktokPixel.helpText2")}</p>
            </div>
          </div>
        </form>
      </div>

      {/* Information Box */}
      <div className="bg-blue-50 dark:!bg-[#181919] rounded-xl p-5 border border-blue-100 dark:!border-[#3c3a3d] mb-6">
        <h3 className="text-lg font-semibold text-blue-800 dark:!text-gray-200 mb-3 flex items-center">
          <Info className="ml-2" size={18} />
          {t("servicePageActivation.tiktokPixel.howToFind.title")}
        </h3>
        <ol className="list-decimal list-inside space-y-2 text-blue-700 dark:!text-gray-400 mr-2">
          <li>{t("servicePageActivation.tiktokPixel.howToFind.step1")}</li>
          <li>{t("servicePageActivation.tiktokPixel.howToFind.step2")}</li>
          <li>{t("servicePageActivation.tiktokPixel.howToFind.step3")}</li>
          <li>{t("servicePageActivation.tiktokPixel.howToFind.step4")}</li>
          <li>{t("servicePageActivation.tiktokPixel.howToFind.step5")}</li>
        </ol>
      </div>

      {/* Coming Soon Feature */}
      <div className="bg-amber-50 dark:!bg-[#181919] rounded-xl p-5 border border-amber-100 dark:!border-[#3c3a3d]">
        <h3 className="text-lg font-semibold text-amber-800 dark:!text-gray-200 mb-2 flex items-center">
          <Clock className="ml-2" size={18} />
          {t("servicePageActivation.tiktokPixel.comingSoon.title")}
        </h3>
        <p className="text-amber-700 dark:!text-gray-400">
          {t("servicePageActivation.tiktokPixel.comingSoon.text")}
        </p>
      </div>
    </div>
  );
}
